// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:29:37.796Z
// Property: Jade Ridge (ID: 6767906449162954)
// Collections: 67 amenities, 15 floorplans (live), 51 photos, 6 POIs, 14 reviews, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162954",
  "property_external_id": "5285857",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/jade-ridge/5XhyFg/",
  "property_apartments_url": "https://www.apartments.com/jade-ridge-phoenix-az/yy37lbs/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": "0",
  "property_slug": "jade-ridge",
  "property_name": "Jade Ridge",
  "property_website_url": "https://www.liveatjaderidge.com/",
  "property_domain": null,
  "property_address": "17625 N 7th St",
  "property_full_address": "17625 N 7th St",
  "property_address_1": "17625 N 7th St",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": "85022-1924",
  "property_address_zip": "85022",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Deer Valley",
  "property_address_latitude": "33.6466715",
  "property_address_longitude": "-112.0651702",
  "property_email": "jade@alvmapts.com",
  "property_phone": "(602) 466-2353",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Jade Ridge in vibrant Phoenix, Arizona, where stunning one, two, and three-bedroom floor plans meet unbeatable amenities. Dive into relaxation by our pool, stay active in the fitness center, or enjoy family fun at the playground. Your ideal lifestyle awaits—find your new home today and schedule a tour!",
  "property_long_description": "**Welcome to Jade Ridge – Your Ideal Phoenix Oasis!**\n\nDiscover the perfect blend of comfort and modern living at Jade Ridge, an exceptional apartment community located in the heart of vibrant Phoenix, Arizona. Offering a variety of thoughtfully designed floor plans, including spacious one, two, and three-bedroom apartments, we cater to your unique lifestyle needs. \n\nAt Jade Ridge, we believe in providing amenities that enhance your quality of life. Take a refreshing dip in our sparkling pool, sweat it out in our fully equipped fitness center, or enjoy quality time with family at our playground. Feel secure with our controlled access features while enjoying the benefits of a walk-up design. Our community also boasts a relaxing spa, a basketball court for the sports enthusiasts, and serene picnic areas with grilling stations for those sunny Arizona afternoons.\n\nStep inside your future apartment and be welcomed by stylish hardwood floors, modern quartz countertops, and stainless steel appliances, including a microwave, refrigerator, oven, and your own washer and dryer. Each apartment is equipped with air conditioning to keep you comfortable year-round.\n\nAt Jade Ridge, you can experience the luxury of a well-appointed home, combined with community features designed for leisure and activity. \n\nWhether you are seeking a cozy one-bedroom or a spacious three-bedroom, your perfect oasis awaits. **Find your new home today – browse our availability or schedule a tour to visit our beautiful community!** Let Jade Ridge be your next destination for upscale living in Phoenix!",
  "property_featured_image": null,
  "property_featured_image_media": null,
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "308",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.93506493506493",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-ab63-755b-abf3-0aa924f09c10.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark Value Management ALVM logo",
    "public_id": "019cfde0-ab63-755b-abf3-0aa924f09c10",
    "storage_key": "property/6767906449162954/019cfde0-ab63-755b-abf3-0aa924f09c10.webp",
    "width": 325,
    "height": 131
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-ab63-755b-abf3-0aa924f09c10.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark Value Management ALVM logo",
    "public_id": "019cfde0-ab63-755b-abf3-0aa924f09c10",
    "storage_key": "property/6767906449162954/019cfde0-ab63-755b-abf3-0aa924f09c10.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "710 - 1225",
  "property_sqft_min": "710",
  "property_sqft_max": "1225",
  "property_price_range": "1099 - 1758.66",
  "property_price_min": "1099",
  "property_price_max": "1758.66",
  "property_available_units": 31,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Nestled in the heart of Phoenix, Jade Ridge offers a vibrant neighborhood where convenience meets culture. From cozy one-bedroom retreats to spacious three-bedroom homes, our community is surrounded by local favorites and must-visit spots. Dive into the richness of the area and uncover what makes Jade Ridge truly special.",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Deer Valley is a family-friendly suburb and residential neighborhood that’s constantly evolving. There are abundant outdoor recreational opportunities in Deer Valley because of its proximity to several natural attractions like Deem Hills and Cave Buttes, both known for scenic hiking and mountain biking trails. Residents have easy access to abundant shopping opportunities without having to leave town at places like Deer Valley Towne Center and Bell Towne Plaza. Deer Valley is home to good public schools and is the ideal suburb for those commuting to Downtown Phoenix and beyond, located less than 20 miles south of town along Interstate 17.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Deer Valley",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Jade Ridge in vibrant Phoenix, Arizona, modern living meets ultimate comfort. Choose from spacious one, two, or three-bedroom floor plans featuring quartz countertops, stainless steel appliances, and hardwood floors. Enjoy crystal-clear days by the pool, energizing workouts in the fitness center, or fun-filled afternoons at the playground.",
  "property_applynow_blurb": "At Jade Ridge in Phoenix, Arizona, our thoughtfully designed floor plans—ranging from one to three bedrooms—offer the perfect blend of comfort and style. Enjoy top-tier amenities like a sparkling pool, state-of-the-art fitness center, and outdoor picnic areas. Elevate your lifestyle; lease your dream apartment online today!",
  "property_contactus_blurb": "At Jade Ridge in Phoenix, Arizona, we offer a range of thoughtfully designed floor plans, including one, two, and three-bedroom apartments to suit your lifestyle. Ready to find your perfect fit? Have questions? Our friendly leasing team is here to help—reach out to us today!",
  "property_faqs_blurb": "At Jade Ridge in vibrant Phoenix, Arizona, we understand your curiosity. Whether you're considering our cozy one-bedroom or spacious three-bedroom layouts, our FAQs page holds the key to your questions. Dive in for insights that bring clarity and comfort to your apartment hunt. Your ideal home awaits!",
  "property_floorplans_blurb": "At Jade Ridge in vibrant Phoenix, Arizona, your dream home awaits. Our thoughtfully designed floor plans cater to every lifestyle, from cozy one-bedrooms to spacious three-bedrooms. Embrace the perfect blend of comfort and style—explore our available apartments today and discover the space that feels just right for you.",
  "property_gallery_blurb": "Step into Jade Ridge, where Phoenix living meets comfort and style. Imagine unwinding by the glistening pool or enjoying a cookout in the picnic area. With various floor plans from one to three bedrooms and modern amenities like stainless steel appliances and quartz countertops, picture yourself calling this vibrant community home!",
  "property_interactivemap_blurb": "At Jade Ridge in sunny Phoenix, Arizona, our thoughtfully designed one, two, and three-bedroom apartment homes offer a perfect blend of comfort and style. Enjoy top-notch amenities like a sparkling pool, state-of-the-art fitness center, and inviting picnic area. Use our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "At Jade Ridge in vibrant Phoenix, Arizona, our diverse floor plans accommodate every lifestyle, from cozy one-bedroom retreats to spacious three-bedroom havens. When friends join, the community flourishes. Spread the word and let your loved ones experience the exceptional living at Jade Ridge—where great friends make great neighbors!",
  "property_residentaccess_blurb": "Welcome to Jade Ridge, your oasis in Phoenix, Arizona. Choose from spacious one, two, or three-bedroom floor plans tailored for your lifestyle. Easily manage your home life by accessing the resident portal—pay rent, schedule maintenance, and connect with your community, all at your fingertips. Your convenience awaits!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257820827",
  "property_scheduletour_blurb": "At Jade Ridge in vibrant Phoenix, Arizona, choose from one, two, or three-bedroom floor plans that suit your lifestyle. Immerse yourself in a community that values comfort and connection. Ready to envision your future home? Schedule a tour today and hear firsthand from our delighted residents!",
  "property_thankyou_blurb": "Thank you for your interest in Jade Ridge, your future home in vibrant Phoenix, Arizona! With thoughtfully designed floor plans from one to three bedrooms, we offer the perfect space to fit your lifestyle. A team member will be in touch soon to help you take the next step toward your new beginning!",
  "property_virtualtours_blurb": "Experience the vibrant lifestyle at Jade Ridge in Phoenix, Arizona, where elegance meets comfort. Choose from our spacious one, two, or three-bedroom floor plans, designed to elevate your living. Ready to envision your new home? Take a virtual tour of our community and discover your perfect fit today!",
  "property_copyright": "2025 All Rights Reserved. Jade Ridge",
  "property_seo_title_home": "Jade Ridge | Apartments in Phoenix, Arizona",
  "property_seo_description_home": "Welcome to Jade Ridge in Phoenix, where stylish living meets exceptional amenities! Choose from one, two, or three-bedroom homes with pools, fitness, and more.",
  "property_seo_title_floorplans": "Find your perfect fit at Jade Ridge in Phoenix! Our spacious one, two, and three-bedroom floor plans cater to your lifestyle. Browse now for your ideal home!",
  "property_seo_description_floorplans": "Find your ideal space at Jade Ridge in Phoenix! Choose from one, two, or three-bedroom layouts tailored for your lifestyle. Browse floor plans today!",
  "property_seo_title_amenities": "Amenities | Phoenix, Arizona Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Jade Ridge in Phoenix! Dive into luxury with our pools, fitness center, and stylish apartments featuring modern amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Phoenix, Arizona",
  "property_seo_description_gallery": "\"Capture the essence of luxury living at Jade Ridge in Phoenix! From stunning one to three-bedroom plans to top-notch amenities, picture your dream life today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Jade Ridge Apartments",
  "property_seo_description_virtualtours": "Experience the vibrant life at Jade Ridge in Phoenix! Take a virtual tour of our stylish one, two, and three-bedroom apartments today! Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Jade Ridge Apartments",
  "property_seo_description_interactivemap": "Find your ideal retreat at Jade Ridge in Phoenix! From spacious one to three-bedroom apartments with top-tier amenities, our interactive map helps you choose your dream home.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Phoenix, Arizona",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Jade Ridge in Phoenix! Dive into local favorites, parks, and hotspots just steps from your one, two, or three-bedroom home.",
  "property_seo_title_contact": "Contact Us | Jade Ridge",
  "property_seo_description_contact": "Connect with Jade Ridge in sunny Phoenix! Whether you need a cozy one-bedroom or a spacious three-bedroom, our leasing team is here to assist. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, Arizona",
  "property_seo_description_faqs": "Find clarity at Jade Ridge in Phoenix! From one to three-bedroom plans, enjoy top-notch amenities like a pool, spa, fitness center, and more. Check our FAQs!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, Arizona",
  "property_seo_description_reviews": "Join the Jade Ridge community in Phoenix, AZ! With stunning amenities and spacious floor plans, see why residents love calling this place home today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Phoenix, Arizona",
  "property_seo_description_applynow": "Elevate your lifestyle at Jade Ridge in Phoenix! Choose from chic 1, 2, or 3 bedroom apartments with top-notch amenities. Apply online and claim your haven!",
  "property_seo_title_residentaccess": "Resident Access | Jade Ridge",
  "property_seo_description_residentaccess": "Unlock convenience at Jade Ridge! Log in to your resident portal to manage payments, request maintenance, and enjoy seamless living in vibrant Phoenix.",
  "property_seo_title_referafriend": "Refer A Friend | Jade Ridge",
  "property_seo_description_referafriend": "\"Great friends make great neighbors at Jade Ridge! Refer a friend and strengthen our vibrant Phoenix community. Join us in creating lasting connections today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Jade Ridge",
  "property_seo_description_scheduletour": "\"Step into luxury at Jade Ridge in Phoenix! Immerse yourself in vibrant community life—schedule your tour today and envision your new home!\"",
  "property_seo_title_privacy": "Privacy Policy | Jade Ridge",
  "property_seo_description_privacy": "Safeguarding your peace of mind at Jade Ridge. Dive into our privacy policy and see how we protect your personal information in sunny Phoenix.",
  "property_seo_title_accessibility": "Website Accessibility | Jade Ridge",
  "property_seo_description_accessibility": "Embrace accessibility at Jade Ridge in Phoenix, Arizona. We prioritize digital inclusion, ensuring everyone can enjoy our vibrant community. Join us online!",
  "property_seo_title_sitemap": "Sitemap | Jade Ridge",
  "property_seo_description_sitemap": "Unearth the layout of Jade Ridge in Phoenix, Arizona. Navigate your future home with ease—check out our sitemap for a seamless journey through our community!",
  "property_seo_title_thankyou": "Thank You | Jade Ridge",
  "property_seo_description_thankyou": "Thank you for reaching out to Jade Ridge in vibrant Phoenix! Our team will be in touch soon to help you find your perfect apartment oasis. ",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1753984524052",
  "amenities": [
    {
      "id": "ec_55bb0b323f0b858567f0040b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef403d3718c5b33865aafab4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_889e1d56eddc338a3f8901ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f94b190ff7a5e8c129c30809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05fc5a9f10168170be64b74b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Curbside",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33720957db3204a9044e0d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Door to Door",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c74de0013780af384b45713a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e4f5961a1369c8716b8b952",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Key Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_384fda14a676808e37fa05b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f3503300d141903df0dca01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d61c6472cb96d1b02e96613",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Breakfast/Coffee Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2cb4977b98c8dec4a2e9eea8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f94a38b844e92923b509a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Fenced Lot",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e21c66667222a4eebdc00fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ccfe64dba85954eaa57cf9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_921878ed76fd2776175897a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69646c880f95a637dfc53975",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a6034245f01e08d2b226741",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcc9fdf7a85d669df5cc57e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_793bc58d827997249b027d83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df524e09ba6de0f4d6774847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Media Center/Movie Theatre",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6da93e7ac3959b1ab0828fff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18516babdc4dd60accdd3e40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78b81d11be93628999446627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "24-Hour Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_252f6cc5e8cc1e31cc0cd7b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Assigned & Covered Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3cb3faac873f560619e15f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Cornhole Boards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4c42c809e47b3f6397eaf4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0408f26c5ebf26c9b97aefd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area With Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b262500754a199cde937b37e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Two Dog Parks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f578a8f8968c6700b792920e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Two Sparkling Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_215965811ef4a056420c0512",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47db00df2458c4a41b319ec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a9f12a5459f883adc5a7788",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1fafa9493c630d0f1803e90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53d12d09158e806526c63586",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a74d2d99ad646e00c1fc4c6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f0dd40f0090771e010a90f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acd351fdf9185eeb5ccfcc15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Vanities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71dba7b64cda41f106ebd9e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfa3da9062315b9d1e84ea46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28e98eaac6502d6e3c78c304",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cc58039256da250f74f757a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed Mirrors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3080d7061f238d5184e51dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Handrails",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fffc50ed93348d55c7f67293",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd3f4d59bdb0d684d76b4434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3152fe80ee5ef2272a97872",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc36eb5bf2790197834f5b75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9ec0330afffe99a1ffe30b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Eat-in Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fc5eade4c2593834aeac479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_551b5733b3ebe8ebd649d4c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc8605681246c3c8aefbc6bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d88fe6379a29c8e0d120ebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bda54853b7730a6eec37860",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6887bc9e3505fd97ef43b773",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c40398c4def8fb3881d3468b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Coffee System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_937a214512ae390951182838",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0c9086d7eb900e921a5f4d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Instant Hot Water",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b51509a2888d6c6b1e3630f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9142b0abfd24324bce9230d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Warming Drawer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0adae64d530f29b49a108b68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cca23ed79f5fe1118ac5c13b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Bookshelves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb2f743d10bdf89f7411abc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50bd90467a63bf46a1d984c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Pane Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9804fd4fe8723da0e7527b1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Furnished",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_762fc6d4e5c53e609e4b5788",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e77a04566e29a652604752d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e752d0c73c237847d7a10d9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "external_id": "false",
      "title": "Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_76e4a7ee0143a61d24e0086e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfddf-f8a4-77bc-8cee-b703905b7b83.webp",
      "image_media": {
        "alt_text": "Property entrance with courtyard, fountain, and lush landscaping.",
        "public_id": "019cfddf-f8a4-77bc-8cee-b703905b7b83",
        "storage_key": "property/6767906449162954/019cfddf-f8a4-77bc-8cee-b703905b7b83.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Welcome to our beautiful property, featuring a serene courtyard with a fountain and abundant greenery, creating a peaceful and inviting atmosphere.",
      "link": "false",
      "alt_text": "Property entrance with courtyard, fountain, and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/V1T9pjqGUJS39KbOc6qk2rR_6_n66CeSCBkpWyuCqoM/102/image.jpg"
    },
    {
      "id": "ec_c9002bf2c63c347f9af99def",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-2644-7501-ab62-0c473061f8f5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019d4d79-2644-7501-ab62-0c473061f8f5",
        "storage_key": "property/6767906449162954/019d4d79-2644-7501-ab62-0c473061f8f5.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/iOl-R3ZinvNpBtuV47VktivEfi8CiOEH6Je4SxZOIzM/102/image.jpg"
    },
    {
      "id": "ec_7fae51d1a34f288a74bee7f8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-2262-736f-99b1-64be1b7d58ec.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances including a microwave and refrigerator, and white cabinetry.",
        "public_id": "019d4d79-2262-736f-99b1-64be1b7d58ec",
        "storage_key": "property/6767906449162954/019d4d79-2262-736f-99b1-64be1b7d58ec.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Explore this beautifully appointed kitchen featuring sleek granite countertops, a microwave, and a refrigerator, perfect for preparing home-cooked meals.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances including a microwave and refrigerator, and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mwyJmHpXLokryHClsdWaJWn6eL0O435HZo7eRhYbKcU/119/image.jpg"
    },
    {
      "id": "ec_8a6b101c3b0713ddc6793b13",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-225c-7239-9c89-dd0ef77470df.webp",
      "image_media": {
        "alt_text": "Kitchen featuring a stainless steel refrigerator, granite countertops, and a deep sink with a pull-down faucet.",
        "public_id": "019d4d79-225c-7239-9c89-dd0ef77470df",
        "storage_key": "property/6767906449162954/019d4d79-225c-7239-9c89-dd0ef77470df.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Modern kitchen space with stainless steel appliances, granite countertops, and ample cabinet space. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen featuring a stainless steel refrigerator, granite countertops, and a deep sink with a pull-down faucet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/IUhFVIwRuAuKGAnRkrmZbdpZuxl9kjFTErOMRKxwW_U/104/image.jpg"
    },
    {
      "id": "ec_900bb68f9817bfc99d8ce55e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-2129-732c-af84-edfa425c5b85.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room with island and stainless steel appliances.",
        "public_id": "019d4d79-2129-732c-af84-edfa425c5b85",
        "storage_key": "property/6767906449162954/019d4d79-2129-732c-af84-edfa425c5b85.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring a stylish kitchen with an island and gleaming stainless steel appliances, seamlessly flowing into a comfortable living area.",
      "link": "false",
      "alt_text": "Modern kitchen and living room with island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4IRh0l85D36Sn8o7ssF9Liz9ST4ApqoSmO0qBqK6nhc/119/image.jpg"
    },
    {
      "id": "ec_08dc9aef609db163ccf61b78",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-23eb-773f-b60c-cde832091211.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d4d79-23eb-773f-b60c-cde832091211",
        "storage_key": "property/6767906449162954/019d4d79-23eb-773f-b60c-cde832091211.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "View of an open-concept kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/VF6bPtPuuHs5wNqfULzJw9XGdfqkUKajoshbsEGMquw/102/image.jpg"
    },
    {
      "id": "ec_19e11819b9b0d773a7c209b6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-4c45-74b0-89c1-03198bc916ad.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with granite countertops, stainless steel appliances, and pendant lighting.",
        "public_id": "019d4d79-4c45-74b0-89c1-03198bc916ad",
        "storage_key": "property/6767906449162954/019d4d79-4c45-74b0-89c1-03198bc916ad.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Stylish dining area adjacent to a modern kitchen, featuring granite countertops, stainless steel appliances, and ample cabinet space for a comfortable living experience.",
      "link": "false",
      "alt_text": "Dining area and kitchen with granite countertops, stainless steel appliances, and pendant lighting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6DV7gd1Dn7MPgUYzZ0e3p74MoLYopXNfXFzzicKQzZc/119/image.jpg"
    },
    {
      "id": "ec_9158019108be5e3906b8fe04",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-3b53-7206-918a-f7333a38e8f1.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island seating and a dining table.",
        "public_id": "019d4d79-3b53-7206-918a-f7333a38e8f1",
        "storage_key": "property/6767906449162954/019d4d79-3b53-7206-918a-f7333a38e8f1.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this open-concept living space, featuring a breakfast bar and a dedicated dining area perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with island seating and a dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZilVKhvd-_1OuotLW2VeoP1oBGQE7njhEYFPRVPHEXo/105/image.jpg"
    },
    {
      "id": "ec_a0022b6b146fe825b66d7923",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-3c39-729e-aff1-4266085d7256.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern furniture and decor.",
        "public_id": "019d4d79-3c39-729e-aff1-4266085d7256",
        "storage_key": "property/6767906449162954/019d4d79-3c39-729e-aff1-4266085d7256.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring contemporary furnishings, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room and dining area with modern furniture and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tqTHJHN0oXzEwK4odRw-7I82V6st3JuvmZKqVRE4qdY/119/image.jpg"
    },
    {
      "id": "ec_18629696ccb7d2203382fe50",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-400d-71de-a4c4-4ea4930cc439.webp",
      "image_media": {
        "alt_text": "A bright living room with a sofa, coffee table, and TV.",
        "public_id": "019d4d79-400d-71de-a4c4-4ea4930cc439",
        "storage_key": "property/6767906449162954/019d4d79-400d-71de-a4c4-4ea4930cc439.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully furnished living room, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "A bright living room with a sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eubs5iAPjBF8CQvbyWdMUQvCq8EPnMvipliAjzo5Hik/104/image.jpg"
    },
    {
      "id": "ec_4bf55f322749861054432b8b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-3db5-733e-b0d1-4ebe0e4d3e2e.webp",
      "image_media": {
        "alt_text": "Living room with a TV, sofa, coffee table, and dining area leading to a kitchen.",
        "public_id": "019d4d79-3db5-733e-b0d1-4ebe0e4d3e2e",
        "storage_key": "property/6767906449162954/019d4d79-3db5-733e-b0d1-4ebe0e4d3e2e.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern entertainment center and a seamless transition to the dining space and kitchen.",
      "link": "false",
      "alt_text": "Living room with a TV, sofa, coffee table, and dining area leading to a kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XFllxa-DnziXGS4ijvTgMcXt4ByKkZvG5lc8Aa_u-dM/118/image.jpg"
    },
    {
      "id": "ec_34341bdb703117e8355faf58",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-5147-7300-ade2-a18a066d22a3.webp",
      "image_media": {
        "alt_text": "King size bed with white linens, flanked by nightstands with lamps, in a neutrally decorated bedroom.",
        "public_id": "019d4d79-5147-7300-ade2-a18a066d22a3",
        "storage_key": "property/6767906449162954/019d4d79-5147-7300-ade2-a18a066d22a3.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, stylish decor, and ample natural light, creating a serene and inviting atmosphere.",
      "link": "false",
      "alt_text": "King size bed with white linens, flanked by nightstands with lamps, in a neutrally decorated bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8tGmvqkanTQ7XkDkZS3wLwSSfIXA7tkFN0Zukenj4s4/105/image.jpg"
    },
    {
      "id": "ec_59596b91159f1b1b799d621a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-52d8-75ac-946e-82b32804d08e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, ceiling fan, and abstract art.",
        "public_id": "019d4d79-52d8-75ac-946e-82b32804d08e",
        "storage_key": "property/6767906449162954/019d4d79-52d8-75ac-946e-82b32804d08e.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bedroom featuring a comfortable king-size bed, modern dresser, and a soothing color palette.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dresser, ceiling fan, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1fPTms3aqKrv43hEzQWAyGNqNiEf8zRe3m3ZcVzRy40/119/image.jpg"
    },
    {
      "id": "ec_22ec2841360b3c321947bebd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-558f-7369-ae5f-bc848607ba39.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, ceiling fan, and walk-in closet.",
        "public_id": "019d4d79-558f-7369-ae5f-bc848607ba39",
        "storage_key": "property/6767906449162954/019d4d79-558f-7369-ae5f-bc848607ba39.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, modern dresser, ceiling fan, and a convenient walk-in closet. Perfect for relaxation and storage.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dresser, ceiling fan, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4rMNCK6eCdqFttP6QOfJSWkFCgXxlUxP5nYJO7bOd9E/104/image.jpg"
    },
    {
      "id": "ec_eacf77efe9cb8c100a97f0cd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-5714-7601-bc94-ca4456f9a272.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white shelves, baskets, and hanging clothes.",
        "public_id": "019d4d79-5714-7601-bc94-ca4456f9a272",
        "storage_key": "property/6767906449162954/019d4d79-5714-7601-bc94-ca4456f9a272.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving, storage baskets, and a hanging rod, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Walk-in closet with white shelves, baskets, and hanging clothes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tAa_QqeuJ87QInCTEwNl3nMOjcQHuHt7tXks8CvoPaM/119/image.jpg"
    },
    {
      "id": "ec_516e356f2f6e731f472e5495",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-6300-76ca-a54c-c204ca55d9ba.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop, white vanity, large mirror, and artwork.",
        "public_id": "019d4d79-6300-76ca-a54c-c204ca55d9ba",
        "storage_key": "property/6767906449162954/019d4d79-6300-76ca-a54c-c204ca55d9ba.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Beautifully appointed bathroom featuring a granite vanity, ample storage, and a spacious mirror. Perfect for your daily routine.",
      "link": "false",
      "alt_text": "Modern bathroom with a granite countertop, white vanity, large mirror, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mPiyYSzRMMcP_0oV9RSI5G4Jrf0KIgdBtaRifBaWfhY/104/image.jpg"
    },
    {
      "id": "ec_090c802a50bb1faf38bac50e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-6666-751d-9710-0b19b9fed96e.webp",
      "image_media": {
        "alt_text": "Clean white bathtub with light blue towels hanging on the wall.",
        "public_id": "019d4d79-6666-751d-9710-0b19b9fed96e",
        "storage_key": "property/6767906449162954/019d4d79-6666-751d-9710-0b19b9fed96e.webp",
        "width": 1620,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Relax and unwind in your spacious bathroom featuring a pristine white bathtub and convenient towel rack.",
      "link": "false",
      "alt_text": "Clean white bathtub with light blue towels hanging on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1N_fLLAiY7sAMq3DRn5zhHLtTHFpg5r8WDWmXPmmOMY/119/image.jpg"
    },
    {
      "id": "ec_09d67d2cfd8bd9fe49f9f190",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-04ff-72f9-8ba1-04b238bb5d40.webp",
      "image_media": {
        "alt_text": "Modern leasing office with computers, chairs, and a large TV.",
        "public_id": "019cfde0-04ff-72f9-8ba1-04b238bb5d40",
        "storage_key": "property/6767906449162954/019cfde0-04ff-72f9-8ba1-04b238bb5d40.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, equipped with computers and comfortable seating for all your needs. A large TV displays helpful information.",
      "link": "false",
      "alt_text": "Modern leasing office with computers, chairs, and a large TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vfPe5nbk3GlNIz3pWRFSoRRCw1SZDMoa4EG7O53mAL8/102/image.jpg"
    },
    {
      "id": "ec_349fe0fdf17da5de99452274",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-0ea8-763e-930f-bacc42a3c7cc.webp",
      "image_media": {
        "alt_text": "Reception desk and waiting area with world maps on the wall.",
        "public_id": "019cfde0-0ea8-763e-930f-bacc42a3c7cc",
        "storage_key": "property/6767906449162954/019cfde0-0ea8-763e-930f-bacc42a3c7cc.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Welcome guests at our modern reception area, featuring a spacious desk, comfortable seating, and world map-inspired decor.",
      "link": "false",
      "alt_text": "Reception desk and waiting area with world maps on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/N7NBMfXe_qhnLHiP-KQ5RbacYj57fWMJ4oi8ysqvAs0/119/image.jpg"
    },
    {
      "id": "ec_59f146a971e21590880b5e7f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-9986-737c-a343-20a9786f0f8a.webp",
      "image_media": {
        "alt_text": "Modern leasing office with multiple workstations and comfortable seating.",
        "public_id": "019d4d79-9986-737c-a343-20a9786f0f8a",
        "storage_key": "property/6767906449162954/019d4d79-9986-737c-a343-20a9786f0f8a.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, featuring ample workstations for our team and comfortable seating for prospective residents. Explore your new home today.",
      "link": "false",
      "alt_text": "Modern leasing office with multiple workstations and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JoHXrqATsQEl6KjbEfqkaWSsjj3MPC9P6pN_ZJ6c9Do/102/image.jpg"
    },
    {
      "id": "ec_e6c22c06aa76754a1afa50d1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-13f8-746f-9223-f498b609907b.webp",
      "image_media": {
        "alt_text": "Stylish community lounge area with modern sofas, armchairs, a coffee table, fireplace, and TV.",
        "public_id": "019cfde0-13f8-746f-9223-f498b609907b",
        "storage_key": "property/6767906449162954/019cfde0-13f8-746f-9223-f498b609907b.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating, a cozy fireplace, and entertainment options for residents.",
      "link": "false",
      "alt_text": "Stylish community lounge area with modern sofas, armchairs, a coffee table, fireplace, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fz6ONzKRG_yFI5H4GSKPO44g5kwgSTb8lZ4uNBjGvJk/119/image.jpg"
    },
    {
      "id": "ec_ca5731c9f8eb8dc7a6a7c28b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-1ace-717f-b587-7fa6390bfb70.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with comfortable seating, high-top tables, and a fireplace.",
        "public_id": "019cfde0-1ace-717f-b587-7fa6390bfb70",
        "storage_key": "property/6767906449162954/019cfde0-1ace-717f-b587-7fa6390bfb70.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring ample seating, high-top tables perfect for work or casual gatherings, and a cozy fireplace.",
      "link": "false",
      "alt_text": "Modern community lounge area with comfortable seating, high-top tables, and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mSbAr6D1VRR7eSpipi8nzIzviEOwZdnNGwWpzij0hNw/102/image.jpg"
    },
    {
      "id": "ec_23f0ff1b5766c7bbe1b4b65d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-1977-72ac-b8d1-5020df6cdec5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a living area with seating.",
        "public_id": "019cfde0-1977-72ac-b8d1-5020df6cdec5",
        "storage_key": "property/6767906449162954/019cfde0-1977-72ac-b8d1-5020df6cdec5.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Experience convenience and comfort in this stylish apartment featuring a modern kitchen and a spacious living area perfect for relaxation and socializing.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and a living area with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZW2tF2tvJFNwyzeRRikuP3IPIEgNuh_4mYUToOTQVeY/119/image.jpg"
    },
    {
      "id": "ec_7aefc788b4351cea5dfc2f9c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-1b4f-77aa-bfa5-523edd3cd88d.webp",
      "image_media": {
        "alt_text": "Modern community lounge with fireplace, TV, seating, and kitchen area.",
        "public_id": "019cfde0-1b4f-77aa-bfa5-523edd3cd88d",
        "storage_key": "property/6767906449162954/019cfde0-1b4f-77aa-bfa5-523edd3cd88d.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a cozy fireplace, comfortable seating, and a convenient kitchen area.",
      "link": "false",
      "alt_text": "Modern community lounge with fireplace, TV, seating, and kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/-UEwH2pzA9_lSDu6_bH-c6t0Bxa6l_1sd7ph9cNoHAA/102/image.jpg"
    },
    {
      "id": "ec_d1b1e8cccef38d7f913a1d3a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-1e73-743a-beec-3001bb8109c1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with fireplace, comfortable seating, and bar seating.",
        "public_id": "019cfde0-1e73-743a-beec-3001bb8109c1",
        "storage_key": "property/6767906449162954/019cfde0-1e73-743a-beec-3001bb8109c1.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring a cozy fireplace, ample seating, and a chic bar area perfect for socializing.",
      "link": "false",
      "alt_text": "Modern lounge area with fireplace, comfortable seating, and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/POajH9geEH2sytoDcQ4tWOQ5Qx7OlEf9w8zqTfi_zBQ/119/image.jpg"
    },
    {
      "id": "ec_8f2199fd66293e794af459e1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-2a1d-734c-a51f-26e89266d8a4.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with manicured landscaping and outdoor seating.",
        "public_id": "019cfde0-2a1d-734c-a51f-26e89266d8a4",
        "storage_key": "property/6767906449162954/019cfde0-2a1d-734c-a51f-26e89266d8a4.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Discover comfortable living in this beautifully maintained apartment community. Enjoy the well-kept grounds and inviting outdoor spaces.",
      "link": "false",
      "alt_text": "Apartment building exterior with manicured landscaping and outdoor seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sfWqoJtGHI_lvCZcmAHH8mDhUaKdN_l5madyiliGskM/102/image.jpg"
    },
    {
      "id": "ec_1a5819f8cc6d51baa85e6e29",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-29c6-774b-849f-e1708e44fd63.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with large windows and well-maintained landscaping.",
        "public_id": "019cfde0-29c6-774b-849f-e1708e44fd63",
        "storage_key": "property/6767906449162954/019cfde0-29c6-774b-849f-e1708e44fd63.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment community, featuring a welcoming exterior and lush green spaces. Explore our amenities and find your perfect home.",
      "link": "false",
      "alt_text": "Exterior view of a modern apartment building with large windows and well-maintained landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4U1VAswks0OPdbDkMgbp-NgQnH4xA4ylmeA183jEvw0/119/image.jpg"
    },
    {
      "id": "ec_151753cfa577f95f3b720402",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-b284-73b2-ac82-c037690b84c1.webp",
      "image_media": {
        "alt_text": "Walkway leading to building entrance with manicured flower beds and outdoor seating area.",
        "public_id": "019d4d79-b284-73b2-ac82-c037690b84c1",
        "storage_key": "property/6767906449162954/019d4d79-b284-73b2-ac82-c037690b84c1.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Welcome to our community's beautifully landscaped grounds, featuring a serene outdoor seating area and a well-maintained walkway leading to the main entrance.",
      "link": "false",
      "alt_text": "Walkway leading to building entrance with manicured flower beds and outdoor seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HTT00eyQ7F2ax4GY8NRA_Ew88D8cwlUlK0doVQTm6Ts/102/image.jpg"
    },
    {
      "id": "ec_11124ce82b0f9a6ef3791bde",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-2ef4-7094-8a8c-0ab0a07f1321.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings and landscaped grounds.",
        "public_id": "019cfde0-2ef4-7094-8a8c-0ab0a07f1321",
        "storage_key": "property/6767906449162954/019cfde0-2ef4-7094-8a8c-0ab0a07f1321.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Discover the beautiful exteriors and lush landscaping of our apartment community, offering a serene and welcoming environment for residents.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings and landscaped grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/A7Df3ka3tqA3xXuGXkvB6QV6Lwvp-F3e_QjUlq5KXZ8/119/image.jpg"
    },
    {
      "id": "ec_ef7a898098d6aff4583d819f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-3467-738d-b05f-da31afc62c27.webp",
      "image_media": {
        "alt_text": "Walkway leading to outdoor grilling area and pool.",
        "public_id": "019cfde0-3467-738d-b05f-da31afc62c27",
        "storage_key": "property/6767906449162954/019cfde0-3467-738d-b05f-da31afc62c27.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our grilling stations and resort-style pool, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Walkway leading to outdoor grilling area and pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/j588lDQ_bUJ2mQ4qqAew_RRAmp0TX9OprrGL51S3ZjE/102/image.jpg"
    },
    {
      "id": "ec_2770251492615380ee14c4bf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-3853-762d-8c84-1e1ce29b53bd.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and umbrellas surrounding it. Buildings and a playground are visible in the background.",
        "public_id": "019cfde0-3853-762d-8c84-1e1ce29b53bd",
        "storage_key": "property/6767906449162954/019cfde0-3853-762d-8c84-1e1ce29b53bd.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool. Lounge chairs and umbrellas are provided for your relaxation and comfort.",
      "link": "false",
      "alt_text": "Bright blue swimming pool with lounge chairs and umbrellas surrounding it. Buildings and a playground are visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OBZV1CHn6YKhdru4JsK2yMDoUE4sQULb7Fb1h3fmDBE/119/image.jpg"
    },
    {
      "id": "ec_d0cea74d2eb70914db6cb3de",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-360b-73c8-8b77-993b04ae69ca.webp",
      "image_media": {
        "alt_text": "Swimming pool and jacuzzi area with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfde0-360b-73c8-8b77-993b04ae69ca",
        "storage_key": "property/6767906449162954/019cfde0-360b-73c8-8b77-993b04ae69ca.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax in the soothing jacuzzi. Lounge chairs and cabanas are available for your comfort.",
      "link": "false",
      "alt_text": "Swimming pool and jacuzzi area with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/torLRMjIHtEsdEZz5vjGCfB93y8hRD-aqtrMb9bVSq4/102/image.jpg"
    },
    {
      "id": "ec_de98c34a8fcddb3827fa3386",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-3fd8-7636-b7f0-6028e6c588e6.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and a covered seating area.",
        "public_id": "019cfde0-3fd8-7636-b7f0-6028e6c588e6",
        "storage_key": "property/6767906449162954/019cfde0-3fd8-7636-b7f0-6028e6c588e6.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool and hot tub, complete with comfortable lounge chairs and a shaded cabana for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and a covered seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Pvc4kRPvojjPv8bEeDgsQh8EyyxuTPrTHtXVh4WLNQI/119/image.jpg"
    },
    {
      "id": "ec_b600d3ed30c6770feccb535b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-406d-75ca-a144-934d7fe650e4.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and umbrellas",
        "public_id": "019cfde0-406d-75ca-a144-934d7fe650e4",
        "storage_key": "property/6767906449162954/019cfde0-406d-75ca-a144-934d7fe650e4.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling pool, surrounded by comfortable lounge chairs perfect for soaking up the sun. A beautiful amenity for relaxation and fun.",
      "link": "false",
      "alt_text": "Resort-style pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/066fKFuzYJjM23SJobkJFOv_S5IK6VCeZvCRn5l_BsI/102/image.jpg"
    },
    {
      "id": "ec_a4b97f079f2e78184e41870c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-4717-7455-b118-6274e46686cc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019cfde0-4717-7455-b118-6274e46686cc",
        "storage_key": "property/6767906449162954/019cfde0-4717-7455-b118-6274e46686cc.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Enjoy the beautiful weather and resort-like atmosphere.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/y5ul2FbfJVouiCi2BrT4P7e40m7FL20lDNJ7kypGChw/119/image.jpg"
    },
    {
      "id": "ec_5cfff8283438921f9d41b6be",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-44eb-714f-9fb7-153a83401151.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with multiple built-in grills and picnic tables on a paved patio.",
        "public_id": "019cfde0-44eb-714f-9fb7-153a83401151",
        "storage_key": "property/6767906449162954/019cfde0-44eb-714f-9fb7-153a83401151.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy sunny days and outdoor cooking with our community's built-in grilling stations and comfortable picnic areas. Perfect for gatherings and dining al fresco.",
      "link": "false",
      "alt_text": "Outdoor grilling area with multiple built-in grills and picnic tables on a paved patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/x1-vEgqISyRL_MBqgkl8ixuf2hgz6i8zeu3VdlvZEwk/102/image.jpg"
    },
    {
      "id": "ec_8e79d05330a9570d3e137bd2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-4c9f-70df-a88d-4026a8d5c97d.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with outdoor stairs and grassy common areas.",
        "public_id": "019cfde0-4c9f-70df-a88d-4026a8d5c97d",
        "storage_key": "property/6767906449162954/019cfde0-4c9f-70df-a88d-4026a8d5c97d.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "View of the apartment buildings, showing the exterior design, walkways, and well-maintained green spaces.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with outdoor stairs and grassy common areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DJF_MnNuQdy2kbOQoH-muzZn_PMWlT-sjgb3J8W8mqI/119/image.jpg"
    },
    {
      "id": "ec_eae7b95fda45cbb13019bbaf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-5f66-71c9-aad6-c0638349526e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with outdoor staircases and a central grassy courtyard.",
        "public_id": "019cfde0-5f66-71c9-aad6-c0638349526e",
        "storage_key": "property/6767906449162954/019cfde0-5f66-71c9-aad6-c0638349526e.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Discover comfortable living in our community, featuring well-maintained exteriors and accessible outdoor spaces perfect for relaxation and enjoying the fresh air.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with outdoor staircases and a central grassy courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NZh1WXhznpan67oOq4beFm9FvdPs-14lqpUwKiv2-hE/102/image.jpg"
    },
    {
      "id": "ec_6d53578b7e4a1c0a8458780c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-5b9e-73e7-988b-b3d186cb91a7.webp",
      "image_media": {
        "alt_text": "Jade Ridge apartments dog park with green fencing and a rules sign.",
        "public_id": "019cfde0-5b9e-73e7-988b-b3d186cb91a7",
        "storage_key": "property/6767906449162954/019cfde0-5b9e-73e7-988b-b3d186cb91a7.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park at Jade Ridge apartments, complete with artificial turf and a clear set of community rules.",
      "link": "false",
      "alt_text": "Jade Ridge apartments dog park with green fencing and a rules sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/glvsTnvEmg85_FSpbdKYkt6TGJYTBwGh5HA00wqSuFc/119/image.jpg"
    },
    {
      "id": "ec_cbac9f2c5631afee01be2f82",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-5f65-7444-9ffc-0674aeb8ef36.webp",
      "image_media": {
        "alt_text": "Fenced-in artificial turf dog park with outdoor stairs and building exterior.",
        "public_id": "019cfde0-5f65-7444-9ffc-0674aeb8ef36",
        "storage_key": "property/6767906449162954/019cfde0-5f65-7444-9ffc-0674aeb8ef36.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, a safe and fun space for your furry friends to play, enclosed by a vibrant green fence and situated near the apartment buildings and outdoor staircases.",
      "link": "false",
      "alt_text": "Fenced-in artificial turf dog park with outdoor stairs and building exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BNejIaMnKjWQejv0_b3jdkG5OZnrdgKIwgX5lIIoVDQ/102/image.jpg"
    },
    {
      "id": "ec_2396b155d64e69fc3621e013",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-608d-752f-a2ce-937c02c8a60a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an outdoor dining area.",
        "public_id": "019cfde0-608d-752f-a2ce-937c02c8a60a",
        "storage_key": "property/6767906449162954/019cfde0-608d-752f-a2ce-937c02c8a60a.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and an outdoor dining area perfect for al fresco meals.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and an outdoor dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tsy7kpt36Ijw15APpCKmOy6pTVe7o0ig4tdDC96l9qU/119/image.jpg"
    },
    {
      "id": "ec_a583b93a919b7fd5ca903bdb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-6a7f-7472-9a89-eebaf0560a05.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfde0-6a7f-7472-9a89-eebaf0560a05",
        "storage_key": "property/6767906449162954/019cfde0-6a7f-7472-9a89-eebaf0560a05.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana for ultimate comfort.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OovPwYNRSMIuD0pbixPLIqqIVTTGtHcZBMZxcmRbHCQ/102/image.jpg"
    },
    {
      "id": "ec_715488e4b294755e43282de3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-6eb6-745c-a4f7-5cbaa785e820.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with picnic tables, grills, and seating near apartment buildings.",
        "public_id": "019cfde0-6eb6-745c-a4f7-5cbaa785e820",
        "storage_key": "property/6767906449162954/019cfde0-6eb6-745c-a4f7-5cbaa785e820.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's patio area, featuring picnic tables and built-in grills, perfect for socializing and dining al fresco.",
      "link": "false",
      "alt_text": "Outdoor patio area with picnic tables, grills, and seating near apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uvQCcx4UKVc-pKbbtMprKtrbWUo56EQ1g4goOWbmIdY/119/image.jpg"
    },
    {
      "id": "ec_3cbd34ac1be067fe6bc3cf25",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-72f2-763f-a904-eef5e7c46cca.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with a hoop and buildings in the background.",
        "public_id": "019cfde0-72f2-763f-a904-eef5e7c46cca",
        "storage_key": "property/6767906449162954/019cfde0-72f2-763f-a904-eef5e7c46cca.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Shoot some hoops on our outdoor basketball court, a great amenity for residents.",
      "link": "false",
      "alt_text": "Outdoor basketball court with a hoop and buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k640os2gO6duwHSrb41ecqvObZLsiv6968jIrW-0ph4/102/image.jpg"
    },
    {
      "id": "ec_301e5590437eae717694dc7e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d5c31-197a-77ff-bcec-c922954f553b.webp",
      "image_media": {
        "alt_text": "Apartment buildings surrounding a grassy courtyard with blooming orange flowers and mature trees.",
        "public_id": "019d5c31-197a-77ff-bcec-c922954f553b",
        "storage_key": "property/6767906449162954/019d5c31-197a-77ff-bcec-c922954f553b.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Discover comfortable living in this charming apartment community, featuring lush green spaces and vibrant floral accents, perfect for a relaxing atmosphere.",
      "link": "false",
      "alt_text": "Apartment buildings surrounding a grassy courtyard with blooming orange flowers and mature trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/52XRNar6-4YEmPz86DwQAojt9NS3jvFxw4eTLhpYA6o/119/image.jpg"
    },
    {
      "id": "ec_0b5cdf7d0f8b430ef62f9906",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-7b3e-7052-96d1-e1d38fec4505.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and playground in the background",
        "public_id": "019cfde0-7b3e-7052-96d1-e1d38fec4505",
        "storage_key": "property/6767906449162954/019cfde0-7b3e-7052-96d1-e1d38fec4505.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with the community grill area and a fun playground for children.",
      "link": "false",
      "alt_text": "Outdoor seating area with grills and playground in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4DUv2Q_0HSDQqbsJjCU5Ho8Cdg9TMhLfSMJ0KLjnH4o/102/image.jpg"
    },
    {
      "id": "ec_f1c512caf8bf5e858667a682",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d5c31-1c28-71ab-bf46-669e4921bffa.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating area with tables and chairs, adjacent to a building with large windows.",
        "public_id": "019d5c31-1c28-71ab-bf46-669e4921bffa",
        "storage_key": "property/6767906449162954/019d5c31-1c28-71ab-bf46-669e4921bffa.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and enjoy the outdoors in our beautifully landscaped patio area, complete with comfortable seating and tables.",
      "link": "false",
      "alt_text": "Outdoor patio seating area with tables and chairs, adjacent to a building with large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/oB956cKmcRb0KCm9oFOSI9Lyc1AtpVeS6-_dA8i1D70/119/image.jpg"
    },
    {
      "id": "ec_e8e7e8837b15986fcbe05429",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-7edd-76bc-a784-10be136f97e5.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and a swimming pool in the background.",
        "public_id": "019cfde0-7edd-76bc-a784-10be136f97e5",
        "storage_key": "property/6767906449162954/019cfde0-7edd-76bc-a784-10be136f97e5.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community grills and nearby swimming pool, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Outdoor seating area with grills and a swimming pool in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fh4R8SgNWmiy_PXAfAkOjdn4JD2UqHAZ_LDdUwLnmY4/102/image.jpg"
    },
    {
      "id": "ec_97911c5f2f4dd7be2b487b5a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-8327-774f-8975-c2c77af9dc77.webp",
      "image_media": {
        "alt_text": "Playground with slide and climbing structure",
        "public_id": "019cfde0-8327-774f-8975-c2c77af9dc77",
        "storage_key": "property/6767906449162954/019cfde0-8327-774f-8975-c2c77af9dc77.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for families.",
      "link": "false",
      "alt_text": "Playground with slide and climbing structure",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZMaDjQSeHP1a_PjNGijdV44GyfuAsY3veehIv4eK6L0/119/image.jpg"
    },
    {
      "id": "ec_8eccdcee57d0181e0ab1c3fa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019cfde0-860c-7178-ad37-668e5f8f0ff5.webp",
      "image_media": {
        "alt_text": "Outdoor picnic table in a courtyard area of an apartment complex.",
        "public_id": "019cfde0-860c-7178-ad37-668e5f8f0ff5",
        "storage_key": "property/6767906449162954/019cfde0-860c-7178-ad37-668e5f8f0ff5.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy casual outdoor dining at the picnic table located in the beautifully landscaped courtyard, perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "Outdoor picnic table in a courtyard area of an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XnOCkYoaNgLnvGOr0CBKzFDC6v_sVQ3Re6wpBHmeHLo/102/image.jpg"
    },
    {
      "id": "ec_ef6941b2843995259dcbc49e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162954/019d4d79-b187-715c-8202-f01a113609f2.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs at Jade Scottsdale.",
        "public_id": "019d4d79-b187-715c-8202-f01a113609f2",
        "storage_key": "property/6767906449162954/019d4d79-b187-715c-8202-f01a113609f2.webp",
        "width": 762,
        "height": 125
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool at Jade Scottsdale, complete with comfortable lounge chairs and a beautiful outdoor setting.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs at Jade Scottsdale.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8X2Nom6-S082tAsjcZB1haZ9Zx_5GamWo3PsrcJVDUA/102/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_bca4fdd17fe2069579c08e59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "poi_name": "Arizona Language Preparatory",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_b8994b65e72eb5ef7458c93a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "poi_name": "Intelli-School - Paradise Valley",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_49ad37fe48cbd49463c85908",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "poi_name": "Christ the King Academy",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_ffb154819e21231cd73ba874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "poi_name": "Paradise Valley Christian Prep",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_9163b6dbb71a35c865acca7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "poi_name": "Holy Cross Lutheran School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_0fe3f622346982cdae33e571",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "source": "apartments",
      "poi_name": "Tutor Time Child Care Learning",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_f93184532f19ad90d96ebbde",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "my overall view of breckenridge is very good it is a well maintained and the staff is very nice i enjoyed my time there looking around he apartments are very nice also",
      "date": "false",
      "title": "review"
    },
    {
      "id": "ec_d1e3baccede2674a97ce44f5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "4",
      "name": "false",
      "text": "I have lived here for approx. 3 months. I found the complex when I was doing some serious apt hunting for cheap prices. I got a 2b/2b (1000ish sq ft) for $600. Which is amazing! Water is included ($50) and I pay $30 a month for my washer and dryer (full size). You can, however, use your own as well and skip the $30. So far the office staff has been polite and I have had no issues. The grounds are pretty and although I haven't used the pools yet, the playground and the gym are a nice bonus. They offer free dvd rental as well in the office. My hubs loves the basketball court too. I really have zero noise issues, except the back gate is kinda loud, but no biggy. I love that its a gated community, so I will take it. I love the apt itself, the only thing I am not too happy with is that the apts done have back patios, just front porches. Still kinda big, but not amazing. I sacrificed the back patio for the price, so that's ok to me. The maintenance took a few days longer to complete my work orders than I was ok with, but when they did fix the issues, they did a great job and were super polite. The location is nice (right down the street from the 101 and lots of shopping). Jimmy Johns delivers here too haha! So far, I love it. I will update in a year and let you know if I have any issues. But so far, I recommend.",
      "date": "false",
      "title": "So far, so good!"
    },
    {
      "id": "ec_b2b24b519bd32534f7ce5670",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "Breckenridge apartments in Phoenix are affordable and in great condition. The office staff is great and will take care of your needs as soon as possible. The only drawback is there is not a lot of parking.",
      "date": "false",
      "title": "Breckenridge is great!"
    },
    {
      "id": "ec_985ce612fa8f305ca28dc605",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "4",
      "name": "false",
      "text": "A great community to live in!  Everyone that works for this apartment community really does treat us like family!  They are always willing to take care of us & make sure any problem gets fixed in a very prompt manner & time frame!  Just an all over great place to live!!",
      "date": "false",
      "title": "Breckenridge Apartments"
    },
    {
      "id": "ec_063b9e2da10667d586d09979",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "Let's start of with friendly staff move to luxurious living space in our 3bd 2bth with private laundry area. Two pools, one is heated next to Jacuzzi, a dog park that's gated as well as the community. The children aren't left out either they have a park and community planned activities monthly.",
      "date": "false",
      "title": "champaign living with beer pockets"
    },
    {
      "id": "ec_bac0a05a08fbbc6c491206d2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "4",
      "name": "false",
      "text": "I have not lived in an apartment in years, but this experience has been exceptional. Everyone from the office staff to my new neighbors have been friendly and helpful. It's a great location with shopping, dining, a park, running trail, and community center, all within walking distance. This place is pet friendly, and family oriented with community activities, a play ground, basketball court, pools, BBQ, and fitness center. What a great place to start fresh.",
      "date": "false",
      "title": "Brekenridge condo/apartment homes."
    },
    {
      "id": "ec_cdf730806e57953481c3cfb0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "\"This oasis in the city truly cares for you: wonderful service, prompt 24 hour maintenance, free Wi-Fi in the club house, a gated community with courtesy patrol, free movie rentals, two pristine pools, and a 24 hour fitness center. Superbly maintained, it offers quick access to everyday shopping and exceptional restaurants, while soothing you with palm trees, fountains, and sunshine.\" \n\nAndrew Sullivan, Phoenix, AZ",
      "date": "false",
      "title": "Convenient, Affordable Paradise"
    },
    {
      "id": "ec_3069c186bebf21ddb8e9577a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "When I had to move into an apartment due to unemployment and other financial reasoning, I was discouraged.  I have 2 dogs & 1 child and I could not imagine not having a home with a yard.  When my 1 year lease was up here, I had to make another difficult decision if I was going to go back to living in a home again, or stay at Breckenridge. My experience (and my daughter's) living at Breckenridge has been so outstanding, we decided to stay another year. The way the mgmt. takes care of their tenants is amazing!  It's a beautiful place with their gardening & so many tall trees that shade us from the AZ sun! From the landscapers who wake me early every Monday morning up to the activities the office arranges for tenant appreciation I don't think can be found done better anywhere else! The way mgmt budgets their money and expenses are always put forth to benefit the tenants. Their decisions on where to put the money in their budget can be seen in the landscaping, the care of the grounds, resurfacing the pool(s), replacing pool furniture whenever it's needed, happy tenants and families and friends we have come close to is next to nothing I've ever had before.  We have private security guards, security gates and 24 hour service when needed. It is so child and pet friendly, & I always feel safe here. When I was in the office today to pick up a package, I patiently waited for the manager to finish up checking in and giving keys to a new tenant. When they were all done with their business, the manager told them to wait one minute, that she had one more thing for them. She went into her office and brought out a Welcome door mat, and a gift basket of goodies that everyone needs during the moving process. Breckenridge goes far beyond what is expected from an apartment building. They have regular outdoor events during holidays and provide tenant safety meetings with the surrounding police and other organizations. It is now tugging on me again whether or not we will move into a house at the end of my lease. I will most likely be signing another year lease coming up at the end of 2015.   Breckenridge should, for sure, be voted one of the best places to live in Phoenix, Arizona. \nSincerely & with great appreciation for what you are doing to help our great nation's families to live just that much better, \nAllison H, Phoenix, AZ",
      "date": "false",
      "title": "Outstanding Living @ Breckenridge Condominiums"
    },
    {
      "id": "ec_a462ecac84733ca84e5d47f6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "This place is great! I moved in a while back and I am very happy here. The leasing office is very accommodating, friendly, helpful and polite. I transferred to a different apartment in the complex and they were so helpful and fixed everything I asked for quickly.  They really care about their tenants being happy and I appreciate that greatly. The office manager Paula is great! She really listens and is willing to do what she can to help. The leasing agents are also fantastic! They are very friendly and any requests you ask for gets done quickly. The maintenance team is super nice and quick to get things done. The apartments are quiet and the rooms are spacious. The area is also great, right by a grocery store and a shopping center. I would recommend this place!",
      "date": "false",
      "title": "Great place!"
    },
    {
      "id": "ec_dc70a3794744f544478b6f70",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "Change is difficult for me and I didn't know how I'd handle Paula and everyone I knew leaving after knowing them for a bit over 5 years, so when Chamberlain and most of all Yesenia took over I was pleasantly surprised.  This property was built in 1983 and before the new owners and Chamberlain took over, it looked like it.  Now though this place is beautiful, the new management and maintenance is exceptional.  Work orders are taken care of ASAP and most of all people are picking up after their dogs now and that was a huge pet peeve of mine.  I live here so I see it as my house and everyone should look at it that way, and in the past residents would trash and disrespect this place every night.  Its nice living here and I enjoy it, its a beautiful quiet property that Chamberlain should be proud to manage.  \n\n                                                                                                                         Thank You,\n",
      "date": "false",
      "title": "Been here since July 2013"
    },
    {
      "id": "ec_20ee5029915236be1a95a2c0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "4",
      "name": "false",
      "text": "We have been here about a month and so far, Management is very kind and quick to respond to concerns. Maintenance is very respectful and come within a day or less, which we did not have at our last apartment rental. The entire complex is being renovated and we are pleased with the new playground and amenities. We weren't even expecting our apartment to be as \"updated\" as it was upon moving in, for such a good rent price. The only problem we had was a noise complaint that we believe wasn't actually meant for us. I look forward to the stairs being updated and more safe. Over all we are glad to be here.",
      "date": "false",
      "title": "This property is greatly improving!"
    },
    {
      "id": "ec_a0ec984d71296e4315e266fa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "The updates that have been done have really improved the overall look and feel of the complex. Maintenance tickets are resolved quickly. The new playground is a nice addition and well as the upgrades made to the pool grounds. The overall look and feel is so much better than when we had first signed our lease to when we moved in",
      "date": "false",
      "title": "New Updates"
    },
    {
      "id": "ec_9f8b396a9003993a1b85c714",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "After 7 years and 2 owners and now the 3rd office/property manager this place is definitely taking a change again for the better.  The new manager Kate is awesome and much nicer than the last, and Linda and Alessia in the office are also incredible. The property itself is being improved too. The maintenance truly does care and gets to residents needs in a timely manner.",
      "date": "false",
      "title": "An awesome change!!"
    },
    {
      "id": "ec_930423ea491950056d773c7d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162954",
      "rating": "5",
      "name": "false",
      "text": "I stopped to see the apartments  and I loved them, great customer service, apartments are beautiful, spacious, great location, people in the office the best, very friendly and provided information I needed super professional ",
      "date": "false",
      "title": "Great Apartments "
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [],
  "custom_fields": []
};

export const generatedAt = '2026-10-05T18:29:37.796Z';
